import StrategyApi from '../api/startegy';
import config from '../config';
import Strategy from '../models/strategy/strategy';
import StrategyStage from '../models/strategy/stage';

const {url, timeout} = config.api.strategy;
const strategyApi = new StrategyApi(url, timeout);

const state = {
  strategies: [],
  stages: {},
};

const getters = {
  clientStages: state => clientId => {
    if (!state.stages[clientId]) {
      return [];
    }

    return state.stages[clientId];
  },
};

const mutations = {
  STRATEGY_SET_STRATEGIES: (state, payload) => {
    state.strategies = payload.items.map(i => (new Strategy(i)));
  },

  STRATEGY_SET_STAGES: (state, payload) => {
    const stages = payload.items.map(i => (new StrategyStage(i)));

    state.stages[payload.clientId] = stages;
    state.stages = Object.assign({}, state.stages);
  },
};

const actions = {
  STRATEGY_LOAD_STRATEGIES: async (context, payload) => {
    const token = context.rootState.token;
    const result = await strategyApi.getStrategies(token);
    const data = { items: result };

    context.commit('STRATEGY_SET_STRATEGIES', data);
  },

  STRATEGY_LOAD_STAGES: async (context, payload) => {
    const token = context.rootState.token;
    const result = await strategyApi.getStages(token, payload);
    const data = { items: result, clientId: payload };

    context.commit('STRATEGY_SET_STAGES', data);
  },

  STRATEGY_ADD_STAGE: async (context, payload) => {
    const token = context.rootState.token;
    const { user, title, goals, dateFrom, dateTo } = payload;

    await strategyApi.addStage(token, { user, title, goals, dateFrom, dateTo });

    await context.dispatch('STRATEGY_LOAD_STAGES', user);
  },

  STRATEGY_UPDATE_STAGE: async (context, payload) => {
    const token = context.rootState.token;
    const { id, user, title, goals, dateFrom, dateTo } = payload;

    await strategyApi.updateStage(token, id, { title, goals, dateFrom, dateTo });

    await context.dispatch('STRATEGY_LOAD_STAGES', user);
  },

  STRATEGY_CHANGE_GOAL_STATUS: async (context, payload) => {
    const token = context.rootState.token;
    const { id, stage, status, user } = payload;

    await strategyApi.changeGoalStatus(token, id, stage, status);

    await context.dispatch('STRATEGY_LOAD_STAGES', user);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
